import { useMemo } from "react";
import View360, { EquirectProjection } from "@egjs/react-view360";
import styled from "styled-components";

interface viewer360Props{
    url: string;
}

const Viewer360: React.FC<viewer360Props> = (p) => {

    const projection = useMemo(() => new EquirectProjection({
        src : p.url
    }), [p.url]);
    
    return (
        <Container>
            <View360
                className="is-16by9"
                projection={projection}
            />
        </Container>
    )
}


const Container = styled.div`
    position: relative;
    width : calc(min(100vh/9*16, 100vw)*0.8);
    height : calc(min(100vh, 100vw/16*9)*0.8);
    user-select: none;
    & canvas{
        width : calc(min(100vh/9*16, 100vw)*0.8);
    height : calc(min(100vh, 100vw/16*9)*0.8);
    }
`
export default Viewer360